/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dropdown, Image, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowDownIcon, SuccessIcon } from "../../../../atoms/CustomIcons";
import { GetDealType } from "../../ducks/types";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";

interface PropsType {
  proposal: any;
  dealsDetailData: GetDealType | null;
  setIsProposalIncomplete: (value: boolean) => void;
}

const emailUrl = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_EMAIL_URL;

export default function Ready(props: PropsType) {
  const navigate = useNavigate();
  const { proposal, dealsDetailData, setIsProposalIncomplete } = props;

  const copyLink = () => {
    const link = `${emailUrl}/proposal-builder/${proposal.id}`;
    navigator.clipboard.writeText(link);
    message.success({
      key: "success",
      type: "success",
      content: (
        <div className="toast_wrapper">
          <div className="toast_text">Link copied</div>
        </div>
      ),
      icon: <SuccessIcon />,
    });
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src="/images/potential-deals/email-icon.svg"
              preview={false}
            />
          }
          onClick={() => {
            if (
              dealsDetailData?.start_date &&
              dealsDetailData?.end_date &&
              dealsDetailData?.billing &&
              dealsDetailData?.net_terms
            ) {
              navigate(`/send-proposal/${proposal.id}`);
            } else {
              setIsProposalIncomplete(true);
            }
          }}
        >
          <span style={{ textAlign: "left", marginTop: "-2px" }}>
            By email <br />
            <span
              style={{
                fontSize: "12px",
                color: "#6C7478",
                lineHeight: "16px",
                display: "block",
              }}
            >
              Send email directly from LandScaling.
            </span>
          </span>
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={
            <Image
              src="/images/potential-deals/link-icon.svg"
              preview={false}
            />
          }
          onClick={(e) => {
            e.stopPropagation();
            copyLink();
          }}
        >
          <span style={{ textAlign: "left", marginTop: "-2px" }}>
            Copy link <br />{" "}
            <span
              style={{
                fontSize: "12px",
                color: "#6C7478",
                lineHeight: "16px",
                display: "block",
              }}
            >
              Copy the link and send it through any <br />
              convenient method.
            </span>
          </span>
        </Button>
      ),
    },
  ];

  return (
    <div
      className="status_card"
      style={{ border: "1px solid #2098EE1A", backgroundColor: "#D3E8FC4D" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/ready.svg" alt="" />
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            htmlType="submit"
            size="large"
            className="light-blue-btn btn-sm"
          >
            Sent to customer{" "}
            <ArrowDownIcon
              style={{ color: "#fff", width: "10px", height: "10px" }}
            />
          </Button>
        </Dropdown>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#44A6F1", fontWeight: "700" }}>Ready</span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        It can be sent to the customer.{" "}
      </h6>
    </div>
  );
}
